import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Quiz from "@/pages/Quiz";
import Results from "@/pages/Results";
import Dashboard from "@/pages/Dashboard";
import Indices from "@/pages/Indices";
import IndexCategory from "@/pages/IndexCategory";
import EntityDetail from "@/pages/EntityDetail";

// After auth, if quiz answers were stashed, auto-submit
function PendingAnswerSubmitter() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user === false) return;
    const pending = sessionStorage.getItem("es_pending_answers");
    if (!pending) return;
    if (location.pathname !== "/quiz" && location.pathname !== "/dashboard") return;
    (async () => {
      try {
        const answers = JSON.parse(pending);
        sessionStorage.removeItem("es_pending_answers");
        const api = (await import("@/lib/api")).default;
        const { data } = await api.post("/assessments", { answers });
        navigate(`/results/${data.id}`);
      } catch (_) {
        sessionStorage.removeItem("es_pending_answers");
      }
    })();
  }, [user, location, navigate]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PendingAnswerSubmitter />
          <Toaster richColors closeButton position="top-right" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/indices" element={<Indices />} />
            <Route path="/indices/:type" element={<IndexCategory />} />
            <Route path="/indices/:type/:slug" element={<EntityDetail />} />
            <Route
              path="/results/:id"
              element={
                <ProtectedRoute>
                  <Results />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Landing />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
